module.exports = __webpack_public_path__ + "static/media/import_2.49549582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/import_2.jpg
// module id = 1854
// module chunks = 0